import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  gridContainer: {
    padding: 24,
    display: 'flex' as any,
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 24,
  },
  serverCardWrapper: {
    flex: '0 0 calc(50% - 12px)' as any,
    minWidth: 600,
  },
  serverCard: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 24,
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' as any,
  },
  chartContainer: {
    height: 80,
    marginBottom: 8,
  },
  metricRow: {
    flexDirection: 'row',
    gap: 24,
    marginBottom: 20,
  },
  metricHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
  },
});